import auth from './modules/auth/auth'
import profiles from './modules/profiles/profiles'
import users from './modules/users/users'
import projects from './modules/projects/projects'
import projectCollaborators from './modules/projects/projectCollaborators'
import biddersPartners from './modules/biddersPartners/biddersPartners'
import responsibles from './modules/biddersPartners/responsibles'
import projectBidders from './modules/projects/projectBidders'
import projectBiddersTeams from './modules/projects/projectBiddersTeams'
import projectPartners from './modules/projects/projectPartners'
import projectPartnersTeams from './modules/projects/projectPartnersTeams'
import projectSteps from './modules/projects/projectSteps'
import projectResults from './modules/projects/projectResults'
import projectTimeline from './modules/projects/projectTimeline'
import projectStepsResponsibles from './modules/projects/projectStepsResponsibles'
import projectFinancialResource from './modules/projects/projectFinancialResource'
import projectApprovals from './modules/projects/projectApprovals'
import utils from './modules/utils/utils'

export default {
  auth,
  profiles,
  users,
  projects,
  projectCollaborators,
  biddersPartners,
  responsibles,
  projectBidders,
  projectBiddersTeams,
  projectPartners,
  projectPartnersTeams,
  projectSteps,
  projectResults,
  projectTimeline,
  projectStepsResponsibles,
  projectFinancialResource,
  projectApprovals,
  utils,
}
